import * as z from 'zod'

// USPS 2-letter codes for the 50 US states + DC.
//
// Const-object + derived type union pattern (not a TS enum): the identifier
// `Region` is both a value namespace (for `Region.CA` autocomplete) and a
// string-literal union type (so bare `'CA'` also satisfies `region: Region`).
// One source of truth — no duplicate string-literal declarations.
export const Region = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  DC: 'DC',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const

export type Region = (typeof Region)[keyof typeof Region]

export const regionSchema = z.enum(Region)

// Runtime coercion for boundary values (third-party lib output, user input,
// legacy string columns). Returns null instead of throwing so callers can
// choose their own fallback (default region, error message, ignore).
export const parseRegion = (
  value: string | null | undefined
): Region | null => {
  if (!value) return null
  const result = regionSchema.safeParse(value)
  return result.success ? result.data : null
}

export { compareRegions } from './compareRegions'
export { REGION_NAMES } from './regionNames'
